module.exports = __webpack_public_path__ + "media/images/___novum-logo-animated-5581a3833b635811f041e9c3eca63aaa.svg";